import $ from 'jquery';
import "lodash";
import * as bootstrap from 'bootstrap';

function isReady(reference) {
  switch(reference) {
  case 'jquery':
    if(typeof($) != 'undefined')
      return true;
    break;
  case 'bootstrap':
    if(typeof(bootstrap) != 'undefined')
      return true;
    break;
  case 'lodash':
    if (typeof (_) != 'undefined')
      return true;
    break;
  case 'box':
    if(typeof(window.Box) != 'undefined')
      return true;
    break;
  case 'box_preview':
    if(isReady('box') && typeof(window.Box.Preview) != 'undefined')
      return true;
    break;
  }
  return false;
}

function allReady() {
  return Array.from(arguments).every(isReady);
}

function waitFor() {
  if(arguments.length < 2)
    throw 'Need code and at least one reference';

  let args = Array.from(arguments),
      code = args.shift();

  let handle = setInterval(function() {
    if(allReady.apply(null, args)) {
      clearInterval(handle);
      code();
    }
  }, 200);
}

export {
  waitFor
};
